/**
 * @generated SignedSource<<b2dd760c5965642029ad8dc86399ae00>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ViewPageConversation_currentUser$data = {
  readonly user: {
    readonly displayName: string | null;
    readonly id: string | null;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ViewPageConversation_currentUser";
};
export type ViewPageConversation_currentUser$key = {
  readonly " $data"?: ViewPageConversation_currentUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewPageConversation_currentUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ViewPageConversation_currentUser",
  "selections": [
    {
      "alias": "user",
      "args": [
        {
          "kind": "Literal",
          "name": "current",
          "value": true
        }
      ],
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "confluence_atlassianUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "displayName"
        },
        {
          "concreteType": "AtlassianUserPhoto",
          "kind": "LinkedField",
          "name": "photos",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isPrimary"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ],
      "storageKey": "confluence_atlassianUser(current:true)"
    }
  ],
  "type": "Query"
};

(node as any).hash = "827270ef4e156b471f2ba4f85ce30b66";

export default node;
